<app-page-header
  [title]="'customer.goPremium.title' | translate"
  theme="premium"
>
  <div leftLinks>
    <ion-icon name="arrow-up-outline" class="text-premium text-2xl"></ion-icon>
  </div>
  <div rightLinks>
    <ion-icon (click)="close()" name="close-outline" class="cursor-pointer text-3xl"></ion-icon>
  </div>
</app-page-header>
<app-customer-page-content class="h-full bg-black text-white overflow-y-auto">
  <div class="text-left text-sm mt-5">
    {{ 'customer.goPremium.convertPremiumAutomatically' | translate:{amountToBePremium: amountToBePremium | money:0} }}.
    {{ 'customer.goPremium.actionsToBegin' | translate }}.
  </div>
  <div class="text-left text-base mt-6">
    <ul class="space-y-2">
      <li>
        <ion-icon name="checkmark-circle-outline" class="font-bold text-premium"></ion-icon>
        <span class="pl-2">{{ 'customer.goPremium.benefits.one' | translate }}</span>
      </li>
      <li>
        <ion-icon name="checkmark-circle-outline" class="font-bold text-premium"></ion-icon>
        <span class="pl-2">{{ 'customer.goPremium.benefits.two' | translate }}</span>
      </li>
      <li>
        <ion-icon name="checkmark-circle-outline" class="font-bold text-premium"></ion-icon>
        <span class="pl-2">{{ 'customer.goPremium.benefits.three' | translate }}</span>
      </li>
      <li>
        <ion-icon name="checkmark-circle-outline" class="font-bold text-premium"></ion-icon>
        <span class="pl-2">{{ 'customer.goPremium.benefits.four' | translate }}</span>
      </li>
      <li>
        <ion-icon name="checkmark-circle-outline" class="font-bold text-premium"></ion-icon>
        <span class="pl-2">{{ 'customer.goPremium.benefits.five' | translate }}</span>
      </li>
    </ul>
  </div>
  <div class="text-left text-xs mt-8">
    <span>{{ 'customer.goPremium.yourDeposits' | translate }}</span>
    <ion-progress-bar class="mt-2 h-1.5 rounded sm:h-2" color="premium" [value]="actualDepositedRatio()"></ion-progress-bar>
    <div class="flex flex-wrap justify-between mt-2">
      <div class="text-left pb-2 w-1/2 sm:pb-0 sm:pr-4">
        {{ actualDepositedAmount | money:0 | showAmounts }}
      </div>
      <span class="text-right pt-2 w-1/2 sm:pt-0 sm:pl-4">{{ amountToBePremium | money:0}}</span>
    </div>
  </div>
  <div>
  </div>
  <div class="flex flex-wrap justify-between mt-10">
    <div class="w-full pb-2 sm:w-1/2 sm:pb-0 sm:pr-4">
      <app-premium-button (click)="goToCashTransferIn()">
        {{ 'customerArea.portfolioActivation.investment.details.accountActivatedStep.options.makeMoneyTransfer' | translate }}
      </app-premium-button>
    </div>
    <div class="w-full pt-2 sm:w-1/2 sm:pt-0 sm:pl-4">
      <app-premium-button (click)="goToTransferFunds()">
        {{ 'customerArea.portfolioActivation.investment.details.accountActivatedStep.options.transferFunds' | translate }}
      </app-premium-button>
    </div>
  </div>
</app-customer-page-content>
